// GENERATED FILE - DO NOT MODIFY
export enum ReceiptOfGoodsQtyValidation {
    Ignore = "I",
    Validate = "V",
    Block = "B",
}

export let nameof = "ReceiptOfGoodsQtyValidation";
